import { FC } from 'react';
import { useEditorData } from '../../lib/FabricJs';
import { useHandleHistory } from '../../lib/FabricJs/hooks/useHandleHistory';
import { replaceQrObject } from '../../lib/FabricJs/utils/qrObject';
import Section from '../Properties/Section';
import QrForm from './QrForm';

// Edits the selected QR code; shown in the properties panel.
const QrCodeSettings: FC<{ object: fabric.Object }> = ({ object }) => {
  const { canvas } = useEditorData();
  const { handleHistory } = useHandleHistory();
  const data = object.data || {};
  // A different QR code selected: the form starts from its settings.
  const formKey = (object as any).id || data.qrContent;

  return (
    <Section title="QR code">
      <QrForm
        key={formKey}
        initial={{
          type: data.qrType,
          input: data.qrInput,
          background: !!object.backgroundColor,
        }}
        submitLabel="Update QR code"
        onSubmit={(settings) => {
          if (!canvas) return;
          replaceQrObject(canvas, object, settings);
          handleHistory(canvas);
        }}
      />
    </Section>
  );
};

export default QrCodeSettings;
